import CardTeamKnowledgeFiles from "@/components/knowledge-base/card-team-knowledge-files";
import CardTeamKnowledgeWebsite from "@/components/knowledge-base/card-team-knowledge-website";

export default function TeamKnowledgePage() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <CardTeamKnowledgeFiles />
      <CardTeamKnowledgeWebsite />
    </div>
  );
}
